/*
 * @Author: Lijiahui
 * @Date: 2020-10-16 11:09:32
 * @LastEditors: Lijiahui
 * @LastEditTime: 2020-10-18 22:17:29
 */
/**
 * @return: 全局常量池
 */

// 接口地址
const APP_API_URL = process.env.VUE_APP_API_BASEURL || "";
export const API = `${APP_API_URL}`;
